module.exports = __webpack_public_path__ + "static/img/mf.897ed829.png";